/* tslint:disable */
/* eslint-disable */
/* @relayHash 16c2fa59c5737760b389dc3ba1f9a96d */

import { ConcreteRequest } from "relay-runtime";
export type IgnoreUserInput = {
    userID: string;
    clientMutationId: string;
};
export type IgnoreUserMutationVariables = {
    input: IgnoreUserInput;
};
export type IgnoreUserMutationResponse = {
    readonly ignoreUser: {
        readonly clientMutationId: string;
    };
};
export type IgnoreUserMutation = {
    readonly response: IgnoreUserMutationResponse;
    readonly variables: IgnoreUserMutationVariables;
};



/*
mutation IgnoreUserMutation(
  $input: IgnoreUserInput!
) {
  ignoreUser(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = [
        ({
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "IgnoreUserPayload",
            "kind": "LinkedField",
            "name": "ignoreUser",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "IgnoreUserMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "IgnoreUserMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "16c2fa59c5737760b389dc3ba1f9a96d",
            "metadata": {},
            "name": "IgnoreUserMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = 'cf86a39d13cf43c50b543ff8861c5373';
export default node;
